/**
 * Transforms string to titlecase
 * @param {String} string To be transformed
 * @return Title Cased String
 */
export const titleCase = (string) => {
    return string.replace(/\b[a-z]/g, (match) => match.toUpperCase());
};
/**
 *  Converts a string to title case
 * @param str  The string to convert
 * @returns  The converted string
 */
export function toTitleCase(str) {
    if (!str)
        return '';
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
/**
 * Converts String or Number into a USD string
 * @param {String} amount The amount to convert
 * @param {Boolean} hideSign If true hides the $ prefix
 * @param {Number} decimalCount How many decimal spaces to show, default is 2
 */
export const formatDBDateObject = (date) => {
    if (!date.unit || !date.value)
        return '';
    switch (date.unit) {
        // case 'WEEKS':
        //   return `${date.value} Weeks`;
        case 'DAYS':
            return `${date.value} Days`;
        default:
            return `${date.value} ${date.unit}`;
    }
};
//# sourceMappingURL=text-formatter.js.map